module.exports = __webpack_public_path__ + "static/lor2-aeccfc13e6e548e91d1663fe30ff7e35.jpg";